import React from 'react';

const STAGES = [
  {
    stage: 'Scope',
    title: 'Discovery & scoping',
    desc: 'We audit your current workflows, find the highest-impact automation opportunities, and agree on a fixed scope together.',
  },
  {
    stage: 'Design',
    title: 'Solution architecture',
    desc: 'We design a solution for the stack you already run, without adding platforms or creating vendor dependencies.',
  },
  {
    stage: 'Build',
    title: 'Build & integration',
    desc: 'We build your workflows, connect them to your tools, and test everything before anything touches production.',
  },
  {
    stage: 'Run',
    title: 'Deploy & optimize',
    desc: 'We deploy with you, then stay on to monitor, refine, and grow your systems as the business does.',
  },
];

// Four stages light in order: a point lights, its line fills toward the next
// card, then a one-second pause before the next stage
const Process = () => (
  <section id="process" className="section" data-testid="process-section">
    <div className="wrap">
      <header className="section-head">
        <h2 className="reveal">Scope it. Build it. Ship it.</h2>
        <p className="lead reveal reveal-1">
          One pipeline from first call to live system. Most projects go live in three to six weeks, at a price we fix before work begins.
        </p>
      </header>
      <ol className="pipeline" data-sequence data-testid="process-stepper">
        {STAGES.map((s, i) => (
          <li key={s.title} className={`pipeline-stage reveal reveal-${i + 1}`} style={{ '--i': i }} data-testid={`process-step-${i + 1}`}>
            <span className="pipeline-point" aria-hidden="true" />
            <h3>{s.title}</h3>
            <p>{s.desc}</p>
            <span className="pipeline-name">{`Stage: ${s.stage}`}</span>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default Process;
